import { useEffect, useState } from "react";
import { useParams, } from "react-router-dom";
import { GenericTable, Spinner, Pagination } from "../../../Components/Common";
import { product_grn_mrr_Labels, product_grn_mrr_Columns, STATUS_COLORS, TABS ,} from "./constants";
import { useGRN } from "../../Project/Hooks/useGRN";
import { formatDateDDMMYYYY, toProperCase } from "../../../Utils";
import { useMRR } from "../Hooks/useMRR";

const GRNComparison = () => {
  const [grnsForMRR, setGrnsForMRR] = useState([]);
  const [mrrGrnMaterials, setMrrGrnMaterials] = useState(null);
  const { instanceId } = useParams();
    const [activeTab, setActiveTab] = useState(TABS.GRN);
    const { fetchMRRGRNMaterials, rowsPerPage, page,loading:loadingMaterials } = useMRR();
    const { fetchGRNs, onPageChange: onGrnPageChange, onPageSizeChange: onGrnPageSizeChange, totalPages: totalGrnPages, rowsPerPage: rowsPerPageGrn, page : Grnpage,loading:loadingGRN } = useGRN();
    
    const loadMRRGRNData = async () => {
        const materials = await fetchMRRGRNMaterials(instanceId);
        setMrrGrnMaterials(materials);
    };

    const getGrns = async () => {
        const grns = await fetchGRNs({ mrr: instanceId });
        setGrnsForMRR(grns);
    }

    useEffect(() => {
        if (activeTab === TABS.GRN) {
            loadMRRGRNData();
        }
    }, [ page, rowsPerPage, instanceId]);

    useEffect(() => {
        if (activeTab === TABS.GRN) {
            getGrns();
        }
    }, [Grnpage, rowsPerPageGrn]);
 
  const renderGRNMRRTable = (column, row) => {
    if (column === "product_name") {
      return (
        <div>
          {row.product_name}
          <span className="text-xs text-gray-500 flex flex-wrap">
            {row.specification}
          </span>
          <span className="text-xs text-gray-500 flex flex-wrap">
            {row.UOM}
          </span>
        </div>
      );
    }

    if (
      ["requested_qty", "received_qty", "damaged_goods_qty", "remaining_qty"].includes(column)
    ) {
      return Number(row[column]).toFixed(2);
    }

    return row[column] || "-";
  };

  const renderGRNCards = (grnsForMRR) => (
  <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
    {grnsForMRR.map((grn) => (
      <div
        key={grn.id}
        className="p-3 border border-gray-200 rounded-lg shadow-sm bg-white hover:shadow-md transition-shadow duration-200"
      >
        <div className="flex justify-between items-center">
          <p className="text-xs text-gray-600">GRN Code</p>
          <p className="text-xs font-semibold text-gray-700">{grn.grn_code || "-"}</p>
        </div>

        <div className="flex justify-between items-center mt-2">
          <p className="text-xs text-gray-600">Received At</p>
          <p className="text-xs font-semibold text-gray-700">{grn.warehouse_detail?.name || "-"}</p>
        </div>

        <div className="flex justify-between items-center mt-2">
          <p className="text-xs text-gray-600">Raised On</p>
          <p className="text-xs font-semibold text-gray-700">
            {formatDateDDMMYYYY(grn.created?.split("T")[0] || "-")}
          </p>
        </div>

        <div className="flex justify-between items-center mt-2">
          <p className="text-xs text-gray-600">Status</p>
          <span
            className={`inline-block mt-0.5 px-2 py-0.5 text-[10px] font-semibold rounded-full ${
              STATUS_COLORS[grn.status] || "bg-gray-100 text-gray-800"
            }`}
          >
            {toProperCase(grn.status || "-")}
          </span>
        </div>
      </div>
    ))}
  </div>
  );
  
  const renderGRNCardsMob = (grnsForMRR) => (
    <div className="block md:hidden">
      <div className="h-[25vh] overflow-y-auto pr-2">
        {grnsForMRR.map((grn) => (
          <div
            key={grn.id}
            className="p-3 border border-gray-200 rounded-lg shadow-sm bg-white mt-2"
          >
            <div className="grid grid-cols-2 gap-x-4 gap-y-2 text-xs text-gray-600">
              <p>
                <span className="font-medium text-gray-700">
                  {grn.grn_code || "-"}
                </span>
              </p>
              <p>
                <span className="font-medium text-gray-700">
                  {grn.warehouse_detail?.name || "-"}
                </span>
              </p>
              <p>
                <span className="font-medium text-gray-700">
                  {formatDateDDMMYYYY(grn.created?.split("T")[0] || "-")}
                </span>
              </p>
              <p className="flex items-center">
                <span
                  className={`inline-block px-2 py-0.5 text-[10px] font-semibold rounded-full ${STATUS_COLORS[grn.status] || "bg-gray-100 text-gray-800"
                    }`}
                >
                  {toProperCase(grn.status || "-")}
                </span>
              </p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );

  return (
    <div className="flex flex-col">
      {activeTab === TABS.GRN && (
        <div className="px-4 py-4">
          {/* Two-column layout */}
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-2">
            {/* Left Column - Goods Received Notes */}
            <div>
              <h3 className="text-lg font-semibold text-primary mb-4 flex items-center gap-1">
                <span className="inline-block w-1.5 h-6 bg-primary rounded-full"></span>
                Goods Received Notes
              </h3>

              <div className="overflow-hidden">
                {loadingGRN ? (
                  <Spinner size={4} />
                ) : grnsForMRR.length > 0 ? (
                  <div className="flex-1 pr-6 border-r border-gray-200">
                    {/* Desktop View */}
                      <div className="h-[400px] hidden md:block overflow-y-auto pr-3">
                        {renderGRNCards(grnsForMRR)}
                      </div>
                      <div className="hidden md:block shrink-0 mt-2">
                        <Pagination
                          page={Grnpage}
                          rowsPerPage={rowsPerPageGrn}
                          onPageChange={onGrnPageChange}
                          onPageSizeChange={onGrnPageSizeChange}
                          totalPages={totalGrnPages}
                        />
                      </div>
                    {/* Mobile View */}
                      <div className="block md:hidden h-[200px] overflow-y-auto pr-2 scrollbar-hide">
                        {renderGRNCardsMob(grnsForMRR)}
                        <div className="shrink-0 mt-2">
                            <Pagination
                                page={Grnpage}
                                rowsPerPage={rowsPerPageGrn}
                                onPageChange={onGrnPageChange}
                                onPageSizeChange={onGrnPageSizeChange}
                                totalPages={totalGrnPages}
                            />
                        </div>
                    </div>
                  </div>
                ) : (
                  <p className="text-gray-500">No GRNs found for this MRR.</p>
                )}
              </div>
            </div>

            {/* Right Column - Material Comparison */}
            <div>
              <h3 className="text-lg font-semibold text-primary mb-4 flex items-center gap-2 mt-5">
                <span className="inline-block w-1.5 h-6 bg-primary rounded-full"></span>
                Material Comparison
              </h3>
              <div className="overflow-x-auto">
                {loadingMaterials ? (
                  <Spinner size={4} />
                ) : mrrGrnMaterials?.materials?.length > 0 ? (
                    <div className="h-[400px] overflow-y-scroll md:h-[400px] md:overflow-y-scroll border border-gray-200 rounded-lg shadow-sm">
                      <GenericTable
                        tableColumns={product_grn_mrr_Columns}
                        columnLabels={product_grn_mrr_Labels}
                        tableRows={mrrGrnMaterials.materials}
                        renderField={renderGRNMRRTable}
                        enableMobileCardView={false}
                      />
                    </div>

                ) : (
                  <p className="text-gray-500">No material comparison data available.</p>
                )}
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default GRNComparison;
